import { Close } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useState } from "react";
import { toast } from "react-toastify";
import useFetch from "src/Components/Common/useFetch";
import { userContext } from "src/Components/Contexts/userContext";
import CustomToast from "src/Components/CustomToast";
import { API_ENDPOINTS } from "src/Utils/ApiConstants/ApiUrlConstants";
import { NdButton } from "../../MsmePartnerPortal/CommonComponents";
import $ from "../../MsmePartnerPortal/PartnerPortal.module.scss";
import BcNewContext from "./BcNewContext";

export default function CompanyBranchSelectModal({ openFilter, setOpenFilter, fetchData, setAppliedFilters }) {
  const { actor } = useContext(userContext);
  const {
    companyIdRef,
    branchCodeRef,
    allBranches,
    allCompanies,
    ListBranchesForCompany,
    lastSelectedBranchRef,
    lastSelectedCompanyRef,
  } = useContext(BcNewContext);
  const [company, setCompany] = useState<any>(lastSelectedCompanyRef.current);
  const [branch, setBranch] = useState<any>(lastSelectedBranchRef.current);

  const handleApplyFilter = () => {
    if (company) {
      lastSelectedCompanyRef.current = company;
    } else {
      toast.error(<CustomToast message="Please Select Company" />);
      return;
    }
    if (actor.branchLevelReconcilation) {
      if (branch) {
        lastSelectedBranchRef.current = branch;
      } else {
        toast.error(<CustomToast message="Please Select Branch" />);
        return;
      }
    }

    companyIdRef.current = company?.companyId;
    saveLastSelectedCompany();
    if (actor.branchLevelReconcilation) {
      branchCodeRef.current = branch?.branchCode;
      saveLastSelectedBranch();
    }
    fetchData();
    setOpenFilter(false);
    setAppliedFilters({});
  };
  const saveLastSelectedBranch = async () => {
    await useFetch(API_ENDPOINTS.SAVE_SELECTED_BRANCH.url, "POST", {
      failureMessage: API_ENDPOINTS.SAVE_SELECTED_BRANCH.failureMessage,
      data: {
        companyId: company.companyId,
        branchCode: branch.branchCode,
        branchName: branch.branchName,
      },
    });
  };
  const saveLastSelectedCompany = async () => {
    await useFetch(API_ENDPOINTS.SAVE_SELECTED_COMPANY.url, "POST", {
      failureMessage: API_ENDPOINTS.SAVE_SELECTED_COMPANY.failureMessage,
      data: {
        companyId: company.companyId,
      },
    });
  };
  return (
    <Dialog open={openFilter} classes={{ paper: $.BR_fix }} maxWidth="sm" fullWidth keepMounted>
      <Box className="dialog_header space_between" alignItems="center" pr={1}>
        <DialogTitle component={"div"} width={"90%"}>
          {actor.branchLevelReconcilation ? "Select Company and Branch" : "Select Company"}
        </DialogTitle>
        <IconButton
          onClick={() => {
            setOpenFilter(false);
          }}
        >
          <Close />
        </IconButton>
      </Box>
      <DialogContent
        sx={{
          display: "flex",
          flexFlow: "column",
          gap: 2,
          px: 3,
          py: 2,
          "& .MuiFormControl-root, & .MuiInputBase-root.MuiOutlinedInput-root": {
            borderRadius: "4px",
          },
        }}
      >
        <div className="vertical_center_align ">
          <Typography variant="subtitle2">Company </Typography>
          <FormControl sx={{ width: 360, ml: "auto" }}>
            <Autocomplete
              isOptionEqualToValue={(option, value) => option?.companyId === value?.companyId}
              disableClearable={true}
              value={company}
              fullWidth={true}
              onChange={(_, value) => {
                setCompany(value);
                if (actor.branchLevelReconcilation) {
                  setBranch(null);
                  if (value) ListBranchesForCompany(value.companyId);
                }
              }}
              size="small"
              id="tags-outlined"
              options={allCompanies || []}
              getOptionLabel={(option) => option.companyName}
              renderInput={(params) => <TextField {...params} label="Select Company" />}
            />
          </FormControl>
        </div>
        {actor.branchLevelReconcilation && (
          <div className="vertical_center_align ">
            <Typography variant="subtitle2">Branch </Typography>
            <FormControl sx={{ width: 360, ml: "auto" }}>
              <Autocomplete
                isOptionEqualToValue={(option, value) => option?.branchCode === value?.branchCode}
                disableClearable={true}
                value={branch}
                fullWidth={true}
                onChange={(_, value) => {
                  setBranch(value);
                }}
                size="small"
                id="tags-outlined"
                options={allBranches || []}
                getOptionLabel={(option) => option.branchName}
                renderInput={(params) => <TextField {...params} label="Select Branch" />}
              />
            </FormControl>
          </div>
        )}
      </DialogContent>
      <DialogActions className="dialog_footer">
        <NdButton variant="contained" id="filterBalanceConfirmation_button" onClick={handleApplyFilter}>
          Apply
        </NdButton>
      </DialogActions>
    </Dialog>
  );
}
